import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_EXERCISE_KEY } from '_api/queries';
import { GET_MY_LIBRARY_EXERCISES_KEY } from '_api/queries/exercise/useGetMyLibraryExercises';
import { Exercise, ExercisePayload } from '_api/types';

export const CREATE_EXERCISE = 'create-exercise';

export const useCreateExercise = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Exercise, ExercisePayload>(
    () => '/exercise/create',
    'post',
    {},
    {
      mutationKey: [CREATE_EXERCISE],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_EXERCISE_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_MY_LIBRARY_EXERCISES_KEY] });
      },
    },
    (body: ExercisePayload) => JSON.stringify(body),
  );
};
